import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ProductCategory } from '../types/product-category';

export const ProductCategoryActions = createActionGroup({
  source: 'Product Category',
  events: {
    'Load Paginated': props<{
      first?: number;
      size?: number;
      sortBy?: string;
      sortDirection?: string;
      searchFields?: any[];
    }>(),
    'Load Paginated Success': props<{
      items: ProductCategory[];
      totalElements: number;
      number: number;
      size: number;
    }>(),
    'Load Paginated Failure': props<{ error: any }>(),
    
    'Save': props<{ active: boolean; code: string; name: string; uuid?: string }>(),
    'Save Success': props<{ item: ProductCategory }>(),
    'Save Failure': props<{ error: any }>(),

    'Delete': props<{ uuid: string }>(),
    'Delete Success': props<{ uuid: string; message: string }>(),
    'Delete Failure': props<{ error: any }>(),
  },
});
